import { render, staticRenderFns } from "./indication.vue?vue&type=template&id=74cf9170&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./indication.vue?vue&type=style&index=0&id=74cf9170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cf9170",
  null
  
)

export default component.exports